// src/components/ui/Divider.tsx
import React from 'react';

interface DividerProps {
  text?: string;
  className?: string;
}

export const Divider: React.FC<DividerProps> = ({ text, className = '' }) => {
  if (text) {
    return (
      <div className={`flex items-center my-6 ${className}`}>
        <div className="flex-grow h-px bg-gradient-to-r from-transparent via-gray-300 dark:via-gray-700 to-transparent" />
        <span className="px-4 text-gray-500 dark:text-gray-400 text-sm font-medium">
          {text}
        </span>
        <div className="flex-grow h-px bg-gradient-to-r from-transparent via-gray-300 dark:via-gray-700 to-transparent" />
      </div>
    );
  }

  return (
    <div className={`flex-grow h-px bg-gradient-to-r from-transparent via-gray-300 dark:via-gray-700 to-transparent my-6 ${className}`} />
  );
};